// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_id-j";
export var fulfillmentFormRail = "_id-i";
export var headerTitleRow = "_id-l";
export var orderDetailsWrapper = "_id-g";
export var orderLinkTrigger = "_id-2";
export var paymentInformationGrid = "_id-q";
export var paymentSummaryColumn = "_id-r";
export var phoneShipmentPickerButton = "_id-e";
export var phoneShipmentPickerButtonContent = "_id-f";
export var phoneShipmentPickerButtonWrapper = "_id-d";
export var phoneShipmentPickerTrigger = "_id-c";
export var shipmentContainer = "_id-k";
export var shipmentDetailsMainPane = "_id-h";
export var shipmentNavigationCard = "_id-a";
export var shipmentNavigationEdgeTrigger = "_id-6";
export var shipmentNavigationRail = "_id-3";
export var shipmentNavigationRailEnter = "_id-5";
export var shipmentNavigationRailHeader = "_id-9";
export var shipmentNavigationRailOverlay = "_id-4";
export var shipmentNavigationScrim = "_id-7";
export var shipmentSummaryFact = "_id-n";
export var shipmentSummaryGrid = "_id-m";
export var shipmentSummaryMetadataRow = "_id-o";
export var shipmentSummaryTags = "_id-p";
export var shipmentWorkspace = "_id-0";
export var shipmentWorkspaceBodyTablet = "_id-8";
export var shipmentWorkspaceContent = "_id-b";
export var shipmentWorkspaceHeader = "_id-1";